"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MenuItem = exports.FileInfoModal = exports.FileInfoMenuItem = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _styles = require("@material-ui/core/styles");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _utils = require("../../utils");
var _tailwind = require("../../tailwind.config");
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["className", "style"],
  _excluded2 = ["attachment", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronButton = function ChevronButton(_ref) {
  var className = _ref.className,
    style = _ref.style,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('text-gray-medium hover:text-primary bg-secondary shadow-md rounded-full w-12 h-12 inline-flex items-center justify-center fixed -mt-6 bg-white z-10', className),
    style: _objectSpread({
      top: '50%'
    }, style)
  }));
};
var _default = exports["default"] = function _default(_ref2) {
  var attachments = _ref2.attachments,
    defaultIndex = _ref2.defaultIndex,
    onChangeIndex = _ref2.onChangeIndex,
    onClose = _ref2.onClose,
    onDownload = _ref2.onDownload,
    onOpenInNewWindow = _ref2.onOpenInNewWindow,
    children = _ref2.children,
    _ref2$singlePage = _ref2.singlePage,
    singlePage = _ref2$singlePage === void 0 ? false : _ref2$singlePage;
  var _useState = (0, _react.useState)(defaultIndex),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var attachment = attachments[index];
  var left = /*#__PURE__*/_react["default"].createElement(AttachmentName, {
    back: !singlePage && /*#__PURE__*/_react["default"].createElement(Close, {
      onClick: onClose
    })
  }, attachment.name);
  var center = /*#__PURE__*/_react["default"].createElement(Download, {
    onClick: function onClick() {
      return onDownload(index);
    }
  });
  var right = /*#__PURE__*/_react["default"].createElement(Menu, null, function (_ref3) {
    var handleClose = _ref3.handleClose;
    return [/*#__PURE__*/_react["default"].createElement(FileInfoMenuItem, {
      key: "fileInfo",
      attachment: attachment,
      onClick: function onClick() {
        handleClose();
      }
    }, t('preview.fileInfo')), !singlePage && /*#__PURE__*/_react["default"].createElement(MenuItem, {
      key: "newWindow",
      onClick: function onClick() {
        onOpenInNewWindow(index);
        handleClose();
      }
    }, "Open in new window")];
  });
  (0, _react.useEffect)(function () {
    var handler = function handler(e) {
      if (e.key === 'ArrowLeft') {
        setIndex(function (index) {
          return index > 0 ? index - 1 : index;
        });
      } else if (e.key === 'ArrowRight') {
        setIndex(function (index) {
          return index < attachments.length - 1 ? index + 1 : index;
        });
      }
    };
    document.addEventListener('keydown', handler);
    return function () {
      return document.removeEventListener('keydown', handler);
    };
  }, [attachments]);
  (0, _react.useEffect)(function () {
    onChangeIndex && onChangeIndex(index);
  }, [index, onChangeIndex]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-col bg-app"
  }, index > 0 && /*#__PURE__*/_react["default"].createElement(ChevronButton, {
    style: {
      left: 12
    },
    onClick: function onClick() {
      return setIndex(function (index) {
        return index - 1;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null)), index < attachments.length - 1 && /*#__PURE__*/_react["default"].createElement(ChevronButton, {
    style: {
      right: 12
    },
    onClick: function onClick() {
      return setIndex(function (index) {
        return index + 1;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('dark:bg-secondary bg-app w-full flex flex-row items-center p-4 shadow flex-shrink-0 z-10')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/4 truncate"
  }, left), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center flex-1"
  }, center), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/4 text-right"
  }, right)), /*#__PURE__*/_react["default"].createElement(children, {
    index: index,
    key: index
  }));
};
var Download = function Download(props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    size: "sm",
    className: "rounded-full text-sm py-2 px-16 !font-normal"
  }, props), t('button.download'));
};
var AttachmentName = function AttachmentName(_ref4) {
  var back = _ref4.back,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-dark text-gray-medium"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-3"
  }, back), children);
};
var Close = function Close(props) {
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], props, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null));
};
var useMenuStyles = (0, _styles.makeStyles)({
  paper: {
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);',
    borderRadius: 0,
    color: _tailwind.theme.colors.gray.medium
  },
  list: {
    padding: 0
  }
});
var Menu = function Menu(_ref5) {
  var children = _ref5.children;
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var handleClose = function handleClose() {
    return setAnchorEl(null);
  };
  var classes = useMenuStyles();
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick(e) {
      return setAnchorEl(e.currentTarget);
    }
  }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], {
    className: "text-light"
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    keepMounted: true,
    classes: classes,
    id: "preview-menu",
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, children({
    handleClose: handleClose
  })));
};
var useMenuItemStyles = (0, _styles.makeStyles)({
  gutters: {
    fontFamily: _tailwind.theme.fontFamily.sans,
    paddingTop: '1.25rem',
    paddingBottom: '1.25rem',
    width: '250px'
  }
});
var MenuItem = exports.MenuItem = function MenuItem(props) {
  var classes = useMenuItemStyles();
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, props, {
    classes: classes,
    disableRipples: true
  }));
};
var FileInfoMenuItem = exports.FileInfoMenuItem = function FileInfoMenuItem(_ref6) {
  var attachment = _ref6.attachment,
    _onClick = _ref6.onClick,
    rest = (0, _objectWithoutProperties2["default"])(_ref6, _excluded2);
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var contentType = attachment.contentType,
    name = attachment.name,
    size = attachment.size;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(MenuItem, (0, _extends2["default"])({}, rest, {
    onClick: function onClick() {
      setOpen(true);
      _onClick();
    }
  })), /*#__PURE__*/_react["default"].createElement(FileInfoModal, {
    isOpen: open,
    toggle: function toggle() {
      return setOpen(function (open) {
        return !open;
      });
    },
    type: (0, _utils.getAttachmentType)(contentType, name),
    size: (0, _utils.formatSize)(size)
  }));
};
var FileInfoModal = exports.FileInfoModal = function FileInfoModal(_ref7) {
  var isOpen = _ref7.isOpen,
    toggle = _ref7.toggle,
    type = _ref7.type,
    size = _ref7.size;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "xs",
    open: isOpen,
    onClose: toggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-10"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-2xl font-bold mb-5"
  }, t('preview.fileInfo.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold mb-5"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-light uppercase"
  }, t('preview.fileInfo.type')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-dark mb-3"
  }, t("preview.fileType.".concat(type))), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-light uppercase"
  }, t('preview.fileInfo.size')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-dark"
  }, size)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-32",
    onClick: toggle
  }, t('button.done'))));
};
//# sourceMappingURL=index.js.map